<script setup>
/* eslint-disable */

import {defineModel} from 'vue'

const durations = defineModel('durations')

const selectedDuration = defineModel('selected-duration')

function lengthToMonthName(duration) {
    if (duration === 1) return "месяц"
    if (duration >= 2 && duration <= 4) return "месяца"
    if (duration >= 5) return "месяцев"
}

function selectDuration(duration) {
    selectedDuration.value = duration
}

</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <div class="w-full bg-white p-4 lg:p-[25px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Выберите длительность тарифа</div>
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 lg:gap-[16px] w-full">
                <div
                    class="flex flex-col justify-center gap-2 items-center p-3 lg:p-[18px] border-2 w-full min-h-[70px] lg:h-[80px] rounded-[16px] relative cursor-pointer duration-200 transition-all"
                    :class="{
                        'bg-blue-50 border-blue-500': dur === selectedDuration,
                        'border-[#e1e1e1] hover:border-blue-300 hover:bg-[#eff8ff]': dur !== selectedDuration,
                    }"
                    v-for="dur in durations" v-bind:key="dur"
                    @click="selectDuration(dur)"
                >
                    <div class="font-bold text-[13px] lg:text-[14px] text-center">
                        {{ dur.month_count }} {{ lengthToMonthName(dur.month_count) }}
                    </div>
                    <div v-if="dur.discount !== 0"
                         class="border border-blue-200 px-2 py-0.5 rounded-full font-bold text-blue-500 text-xs lg:text-sm">
                        -{{ dur.discount }}%
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>